import { render, staticRenderFns } from "./branchPanel.vue?vue&type=template&id=77f40780&"
import script from "./branchPanel.vue?vue&type=script&lang=js&"
export * from "./branchPanel.vue?vue&type=script&lang=js&"
import style0 from "./branchPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports